import type { GenericLanguages } from '@payloadcms/translations'

export const i18n: Partial<GenericLanguages> = {
  ar: {
    decreaseLabel: 'تقليل المسافة البادئة',
    increaseLabel: 'زيادة المسافة البادئة',
  },
  az: {
    decreaseLabel: 'İntervalı Azaltın',
    increaseLabel: 'Girintiyi Artırın',
  },
  bg: {
    decreaseLabel: 'Намали отстоянието',
    increaseLabel: 'Увеличете отстоянието',
  },
  cs: {
    decreaseLabel: 'Zmenšit odsazení',
    increaseLabel: 'Zvětšit odsazení',
  },
  da: {
    decreaseLabel: 'Reducer Indrykning',
    increaseLabel: 'Forøg indrykning',
  },
  de: {
    decreaseLabel: 'Einzug verkleinern',
    increaseLabel: 'Einzug erhöhen',
  },
  en: {
    decreaseLabel: 'Decrease Indent',
    increaseLabel: 'Increase Indent',
  },
  es: {
    decreaseLabel: 'Disminuir Sangría',
    increaseLabel: 'Aumentar Sangría',
  },
  et: {
    decreaseLabel: 'Taande vähendamine',
    increaseLabel: 'Taande suurendamine',
  },
  fa: {
    decreaseLabel: 'کاهش تورفتگی',
    increaseLabel: 'افزایش تورفتگی',
  },
  fr: {
    decreaseLabel: "Diminuer l'indentation",
    increaseLabel: "Augmenter l'indentation",
  },
  he: {
    decreaseLabel: 'הקטן הזחה',
    increaseLabel: 'הגדל כניסה',
  },
  hr: {
    decreaseLabel: 'Smanji uvlačenje',
    increaseLabel: 'Povećaj uvlačenje',
  },
  hu: {
    decreaseLabel: 'Csökkentse a behúzást',
    increaseLabel: 'Behúzás növelése',
  },
  is: {
    decreaseLabel: 'Minnka inndrátt',
    increaseLabel: 'Auka inndrátt',
  },
  it: {
    decreaseLabel: 'Diminuisci rientro',
    increaseLabel: 'Aumenta Rientro',
  },
  ja: {
    decreaseLabel: 'インデントを減らす',
    increaseLabel: 'インデントを増やす',
  },
  ko: {
    decreaseLabel: '들여쓰기 줄이기',
    increaseLabel: '들여쓰기 늘리기',
  },
  my: {
    decreaseLabel: 'Kurangkan Inden',
    increaseLabel: 'Tingkatkan Inden',
  },
  nb: {
    decreaseLabel: 'Reduser innrykk',
    increaseLabel: 'Øke innrykk',
  },
  nl: {
    decreaseLabel: 'Verminder Inspringing',
    increaseLabel: 'Inspring verhogen',
  },
  pl: {
    decreaseLabel: 'Zmniejsz wcięcie',
    increaseLabel: 'Zwiększ wcięcie',
  },
  pt: {
    decreaseLabel: 'Diminuir recuo',
    increaseLabel: 'Aumentar Indentação',
  },
  ro: {
    decreaseLabel: 'Reducere indentare',
    increaseLabel: 'Crește indentarea',
  },
  rs: {
    decreaseLabel: 'Смањи увлачење',
    increaseLabel: 'Повећај увлачење',
  },
  'rs-latin': {
    decreaseLabel: 'Smanji uvlačenje',
    increaseLabel: 'Povećaj uvlačenje',
  },
  ru: {
    decreaseLabel: 'Уменьшить отступ',
    increaseLabel: 'Увеличить отступ',
  },
  sk: {
    decreaseLabel: 'Znížiť odsadenie',
    increaseLabel: 'Zväčšiť odsadenie',
  },
  sl: {
    decreaseLabel: 'Zmanjšaj zamik',
    increaseLabel: 'Povečaj zamik',
  },
  sv: {
    decreaseLabel: 'Minska indrag',
    increaseLabel: 'Öka indrag',
  },
  ta: {
    decreaseLabel: 'இடதுபுறச் செருகலை குறைக்கவும்',
    increaseLabel: 'இடதுபுறச் செருகலை அதிகரிக்கவும்',
  },
  th: {
    decreaseLabel: 'ลดการเยื้อง',
    increaseLabel: 'เพิ่มการเยื้อง',
  },
  tr: {
    decreaseLabel: 'Girintiyi Azalt',
    increaseLabel: 'Girintiyi Artır',
  },
  uk: {
    decreaseLabel: 'Зменшити відступ',
    increaseLabel: 'Збільшити відступ',
  },
  vi: {
    decreaseLabel: 'Giảm lề',
    increaseLabel: 'Tăng lề',
  },
  zh: {
    decreaseLabel: '减少缩进',
    increaseLabel: '增加缩进',
  },
  'zh-TW': {
    decreaseLabel: '減少縮排',
    increaseLabel: '增加縮排',
  },
}
